export const environment = {
  production: true,
  sharedConfig: {
    applicationName: 'ClubHub',
  },
  sentry: {
    dsn: 'https://a92e7b1da6032fb1b54907f6655e73c2@sentry.theidolops.com/68',
  },
};
